<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="row">
      <div class="col col-md-4 col-lg-4 hidden-sm-down">
        <img src="/img/450.png" class="w-100 opacity-20" aria-roledescription="logo" alt="" />
      </div>

      <div class="col-sm-12 col-md-8 col-lg-8 col-xl-7 ml-auto">
        <div class="p-4 rounded-0 bg-faded logowanie">
          <h1 class="h1 text-left fw-700 mb-4 d-xs-block">
            Zapomniałem hasła
          </h1>

          <div class="mb-4 label">
            Wpisz
            <b>adres e-mail</b>, na który ma być wysłana <b class="text-nowrap">wiadomość z linkiem</b>&nbsp;

            <b class="text-nowrap">do zmiany hasła*</b>
          </div>

          <form @submit.prevent="submit">
            <div class="form-group">
              <w-input title-attribute="Adres e-mail" :model="$schema.email" />

              <div class="help-block">
                *Nie dotyczy kont Zintegrowanego Systemu Oświatowego
              </div>
            </div>

            <div class="col-sm-12 text-right">
              <button type="submit" class="btn btn-danger btn-lg rounded-pill">
                Wyślij wiadomość
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import { authResource } from '@/resources/auth.resource';
import schema from '@/schemas/resetPassword.schema';
import { serverError } from '@/utils/serverError';

// @vuese
// Resetowanie hasła
// @group StartRoute
export default {
  name: 'Reset',
  mixins: [formMixin, notificationsMixin],
  schema,
  data() {
    return {
      model: {
        email: ''
      }
    };
  },
  computed: mapState({
    appTitle: state => state.system.appTitle
  }),
  mounted() {
    document.title = 'Zapomniałem hasła' + ' - ' + this.appTitle;
  },
  methods: {
    // @vuese
    // Wysyła maila z resetem hasła
    submit() {
      if (!this.$schema.$validateAll().length) {
        authResource
          .resetPassword(this.model.email)
          .then(() =>
            this.$store.commit('showConfirm', {
              title: 'Została wysłana wiadomość e-mail z linkiem do resetowania hasła',
              showCloseButton: false,
              submitButton: 'Ok',
              onSuccess: () => this.$router.push({ name: 'login' })
            })
          )
          .catch(err => this.notifyError(serverError(err.message || Errors.ERROR_TRY_AGAIN_LATER)));
      }
    }
  }
};
</script>

<style scoped>
.btn.btn-danger {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 1.2rem;
}
</style>
